// The Meta family — one connectable provider.
//
// `meta_catalog`, `meta_pixel` and `facebook_page` are NOT here: they are registered from inside
// `MetaIntegration.vue`, never appear in `INTEGRATIONS_CONFIGS`, and exist only as display rows.
// They are modelled in `channels.ts` as sub-entities of this provider.
//
// `meta_cpas_account` is likewise absent, but for a different reason: v3 DELETED its
// `INTEGRATIONS_CONFIGS` entry (Orphex-New-Front `e2e0c90e`, "refactor(onboarding): overhaul new
// workspace modal flow"). `CpasIntegration.vue` still sits on disk with zero importers. So the
// ticket's "port CPAS with `comingSoon: true`" has no source to port — the analysis' "5th DROP"
// already happened upstream. Its permission row survives in `channels.ts`.

import type { IntegrationProvider } from '../providers.types'

export const META_PROVIDERS: readonly IntegrationProvider[] = [
  {
    key: 'meta_ads_account',
    id: 'meta_ads_account',
    nameKey: 'integrations.providers.metaAds',
    category: 'paid_advertising',
    authFamily: 'meta_email',
    connect: 'oauth',
    labelFields: ['name', 'meta_account_id'],
    allowsMultiple: true,
    logo: 'meta_ads',
    configComponent: () => import('../../components/connectors/MetaConnector.vue'),
  },
]
